<template>
    <div>
        <div class="w3-padding flow-card w3-border-0">
            <h1 class="flow-blue-color w3-center">
                <span class="logo flow-margin-right">
                    <img src="logo.png"/>
                </span>
                <span>Partheas Flow</span>
            </h1>
        </div>

        <!--TODO: Remove inline css-->
        <div style="margin: 2% 10% 5% 10%">

            <div v-if="userLoaded">
                <div v-if="isAccountComplete === true">
                    <router-link :to="{name: 'dashboard'}"
                                 class="flow-btn w3-btn w3-round w3-border w3-round-medium flow-blue-color w3-padding-large w3-margin-bottom">
                        <i class="fa fa-home flow-green-active-color"></i>
                        <span><b class="flow-margin-left">{{ $t('dashboard') }}</b></span>
                    </router-link>

                    <account-details :overview="overview"></account-details>

                </div>

                <div v-if="isAccountComplete === false">
                    <update-self-account :overview="overview"></update-self-account>
                </div>
            </div>

        </div>

    </div>


</template>

<script>
import Vue from 'vue';
import UpdateSelfAccount from "../components/account/UpdateSelfAccount";
import AccountDetails from "../components/account/AccountDetails";

const frc = Vue.prototype.$frc;

    export default {
        name: "AccountSetup",
        components: {AccountDetails, UpdateSelfAccount},
        data() {
            return {
                isAccountComplete: undefined,
                overview: undefined,
                userLoaded: false
            }
        },
        mounted() {
            this.getCurrentUser();
            this.setAccountCompleteStatus();
        },
        methods: {
            setAccountCompleteStatus() {
                const app = this;
                frc.isAccountComplete().then(function (res) {
                    app.isAccountComplete = res.data;
                });
            },
            getCurrentUser() {
                const app = this;
                frc.getCurrentUser().then(function(res) {
                    const overview = res.data.overview;
                    Vue.setLocale(overview.user.language);
                    app.overview = overview;
                    app.addPhysicians();
                });
            },
            addPhysicians() {
              const app = this;
              app.overview.user.physicians = [];
              if (!app.overview.user.userAgendaPhysicians) {
                app.userLoaded = true;
                return;
              }

              let linkedPhysicians = app.overview.user.userAgendaPhysicians;
              let noOfPhysiciansLoaded = linkedPhysicians.length;
              if (noOfPhysiciansLoaded === 0) {
                app.userLoaded = true;
                return;
              }
              for (let i in linkedPhysicians) {
                frc.getPhysicianWithId(linkedPhysicians[i]).then(function (res) {
                  app.overview.user.physicians.push(res.data);
                }).finally(function () {
                  app.userLoaded = --noOfPhysiciansLoaded === 0;
                });
              }
            }
        }
    }
</script>

<style scoped>

</style>